import { useState, Suspense } from 'react'
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import InputMask from 'react-input-mask'
import { FaCheckCircle } from "react-icons/fa"
import emailService from '../services/EmailService'

import termoDeAdesao from '../assets/documents/CT_CLEANFOODS_TERMO_DE_ADESAO.pdf'

function PageRenderer({ page }) {
  const [loading, setLoading] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [hideRegisterButton, setHideRegisterButton] = useState(false);
  const [hidePaymentButton, setHidePaymentButton] = useState(true);

  const [firstName, setFirstName] = useState(null);
  const [firstNameInvalid, setFirstNameInvalid] = useState(false);
  const [firstNameErrorMessage, setFirstNameErrorMessage] = useState('Campo obrigatório');

  const [lastName, setLastName] = useState(null);
  const [lastNameInvalid, setLastNameInvalid] = useState(false);
  const [lastNameErrorMessage, setLastNameErrorMessage] = useState('Campo obrigatório');

  const [birthDate, setBirthDate] = useState(null);
  const [birthDateInvalid, setBirthDateInvalid] = useState(false);
  const [birthDateErrorMessage, setBirthDateErrorMessage] = useState('Campo obrigatório');

  const [document, setDocument] = useState(null);
  const [documentInvalid, setDocumentInvalid] = useState(false);
  const [documentErrorMessage, setDocumentErrorMessage] = useState('Campo obrigatório');

  const [email, setEmail] = useState(null);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('Campo obrigatório');

  const [phone, setPhone] = useState(null);
  const [phoneInvalid, setPhoneInvalid] = useState(false);
  const [phoneErrorMessage, setPhoneErrorMessage] = useState('Campo obrigatório');

  const firstNameValidation = (name) => {
    if (!name || name.length === 0) {
      setFirstNameErrorMessage('Campo obrigatório');
      setFirstNameInvalid(true);
      setFormIsValid(false);
    } else if (name.length < 3) {
      setFirstNameErrorMessage('Nome muito curto');
      setFirstNameInvalid(true);
      setFormIsValid(false);
    } else if (name.length > 50) {
      setFirstNameErrorMessage('Nome muito longo');
      setFirstNameInvalid(true);
      setFormIsValid(false);
    } else {
      setFirstNameInvalid(false);
      setFormIsValid(true);
    }
  }

  const lastNameValidation = (lastName) => {
    if (!lastName || lastName.length === 0) {
      setLastNameErrorMessage('Campo obrigatório');
      setLastNameInvalid(true);
      setFormIsValid(false);
    } else if (lastName.length < 3) {
      setLastNameErrorMessage('Sobrenome muito curto');
      setLastNameInvalid(true);
      setFormIsValid(false);
    } else if (lastName.length > 50) {
      setLastNameErrorMessage('Sobrenome muito longo');
      setLastNameInvalid(true);
      setFormIsValid(false);
    } else {
      setLastNameInvalid(false);
      setFormIsValid(true);
    }
  }

  const birthDateValidation = (data) => {
    const birthDate = data.target.value
    if (!birthDate || birthDate.length === 0) {
      setBirthDateErrorMessage('Campo obrigatório');
      setBirthDateInvalid(true);
      setFormIsValid(false);
    } else if (!validarData(birthDate)) {
      setBirthDateErrorMessage('Data inválida');
      setBirthDateInvalid(true);
      setFormIsValid(false);
    } else {
      setBirthDateInvalid(false);
      setFormIsValid(true);
    }
  }

  const documentValidation = () => {
    const onlyDigits = document.replace(/\D/g, '');
    if (!document || onlyDigits.length === 0) {
      setDocumentErrorMessage('Campo obrigatório');
      setDocumentInvalid(true);
      setFormIsValid(false);
    } else if (!validarCPF(onlyDigits)) {
      setDocumentErrorMessage('CPF inválido');
      setDocumentInvalid(true);
      setFormIsValid(false);
    } else {
      setDocumentInvalid(false);
      setFormIsValid(true);
    }
  }

  const emailValidation = (email) => {
    if (!email || email.length === 0) {
      setEmailErrorMessage('Campo obrigatório');
      setEmailInvalid(true);
      setFormIsValid(false);
    } else if (!validarEmail(email)) {
      setEmailErrorMessage('Email inválido');
      setEmailInvalid(true);
      setFormIsValid(false);
    } else {
      setEmailInvalid(false);
      setFormIsValid(true);
    }
  }

  const phoneValidation = (phone) => {
    const onlyDigits = phone.replace(/\D/g, '')
    if (!onlyDigits || onlyDigits.length === 0) {
      setPhoneErrorMessage('Campo obrigatório');
      setPhoneInvalid(true);
      setFormIsValid(false);
    } else if (!validarCelular(phone)) {
      setPhoneErrorMessage('Celular inválido');
      setPhoneInvalid(true);
      setFormIsValid(false);
    } else {
      setPhoneInvalid(false);
      setFormIsValid(true);
    }
  }

  const validarCPF = (cpf) => {
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false

    let soma = 0
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i)
    let resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cpf.charAt(9))) return false

    soma = 0
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i)
    resto = 11 - (soma % 11)
    if (resto === 10 || resto === 11) resto = 0
    return resto === parseInt(cpf.charAt(10))
  }

  const validarData = (data) => {
    const [dia, mes, ano] = data.split('/')
    const d = new Date(`${ano}-${mes}-${dia}`)
    const hoje = new Date()
    return (
      /^\d{2}\/\d{2}\/\d{4}$/.test(data) &&
      d <= hoje
    )
  }

  const validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const validarCelular = (cel) => {
    return /^\(\d{2}\) \d{5}-\d{4}$/.test(cel)
  }

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();

      const emptyFields = [];

      const form = event.currentTarget;
      const formElements = Array.from(form.elements);
      formElements.forEach((element) => {
        if (
          element.tagName === 'INPUT' ||
          element.tagName === 'SELECT' ||
          element.tagName === 'TEXTAREA'
        ) {
          if (element.hasAttribute('required') && !element.value.trim()) {
            emptyFields.push(element.name || element.id || '[campo sem nome]');
            if (element.name === 'firstName') {
              setFirstNameInvalid(true);
              setFirstNameErrorMessage('Campo obrigatório');
            }
            if (element.name === 'lastName') {
              setLastNameInvalid(true);
              setLastNameErrorMessage('Campo obrigatório');
            }
            if (element.name === 'birthDate') { 
              setBirthDateInvalid(true);
              setBirthDateErrorMessage('Campo obrigatório');
            }
            if (element.name === 'document') {
              setDocumentInvalid(true);
              setDocumentErrorMessage('Campo obrigatório');
            }
            if (element.name === 'email') {
              setEmailInvalid(true);
              setEmailErrorMessage('Campo obrigatório');
            }
            if (element.name === 'phone') {
              setPhoneInvalid(true);
              setPhoneErrorMessage('Campo obrigatório');
            }
          }
        }
      });

      if (form.checkValidity() === false) {
        event.stopPropagation();
      } else {
        if (!formIsValid) {
          console.log('Formulário inválido');
          return;
        } else {
          setLoading(true);
          const params = {
            'fromName': '[Site] CT Clean Foods',
            'fromEmail': 'contato@nois.dev.br',
            'toName': 'CT Clean Foods',
            'toEmail': 'ctcleanfoods@hotmail.com',
            'subject': 'Mensagem enviada pelo formulário do site',
            'text':  `Nome: ${firstName} ${lastName}\nData de Nascimento: ${birthDate}\nCPF: ${document}\nE-mail: ${email}\nCelular: ${phone}`
          };
          // Enviar email 
          const response = await emailService.sendMail(params)
          console.log('Response:', response)
          // Redirecionar para pagina de pagamento
          setTimeout(() => {
            setHideRegisterButton(true);
            setHidePaymentButton(false);
            setLoading(false);
          }, 3000);
        }
      }
    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);
      setLoading(false);
    }
  }
  return (
    <Suspense fallback={<div>Carregando elementos...</div>}>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.title} />
        <meta property="og:title" content={page.title} />
        <meta property="og:description" content={page.title} />
        <meta property="og:image" content={page.title} />
      </Helmet>
      <Container>
        {/* {page.components.map((component) => {
          return Object.values(component.elements.content).map((content) => {
            return createElement(content)
          })
        })} */}
        <Row style={{ padding: '20px' }}>
          <Col xs={12} sm={12} md={12} lg={{ span: 6, offset: 3 }} className='destaque border-primaria' >
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} style={{ fontSize: '34px', fontWeight: '800' }}>
                <div>
                  PLANO FIDELIDADE
                </div>
                <div>
                  12 MESES
                </div>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className='texto-primaria' style={{ fontSize: '60px', fontWeight: '800' }}>
                  179,90
                </span>
              </Col>
              <Col className='mt-3' xs={12} sm={12} md={12} lg={12}>
                <span style={{ fontWeight: '600', color: '#DDD' }}>
                  <div style={{ fontSize: '24px' }}>
                    TAXA DE CANCELAMENTO
                  </div>
                  <div style={{ fontSize: '20px' }}>
                     (1 MENSALIDADE)
                  </div>
                </span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} className='itens'>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                    <FaCheckCircle size={20} className='texto-primaria' style={{ marginRight: '8px' }} />
                    <span className='itens-text'>TAXA DE MATRÍCULA ISENTA</span>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                    <FaCheckCircle size={20} className='texto-primaria' style={{ marginRight: '8px' }} />
                    <span className='itens-text'>SEM TAXA DE MANUTENÇÃO</span>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                    <FaCheckCircle size={20} className='texto-primaria' style={{ marginRight: '8px' }} />
                    <span className='itens-text'>ÁREA DE CARDIO</span>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                    <FaCheckCircle size={20} className='texto-primaria' style={{ marginRight: '8px' }} />
                    <span className='itens-text'>MUSCULAÇÃO</span>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                    <FaCheckCircle size={20} className='texto-primaria' style={{ marginRight: '8px' }} />
                    <span className='itens-text'>DIREITO A 3 CONVIDADOS POR MÊS</span>
                  </li>
                </ul>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <div style={{ marginTop: '30px' }}>
                  <span style={{ fontSize: '28px', fontWeight: '700' }}>
                    PREENCHA SEUS DADOS
                  </span>
                </div>
              </Col>
              <Col>
                <Form noValidate onSubmit={handleSubmit} className='form-contact' style={{ textAlign: 'left' }}>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Form.Group className="mb-3" controlId="firstName">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                          required 
                          name="firstName"
                          type="text"
                          placeholder="Digite seu nome"
                          onChange={e => setFirstName(e.target.value)}
                          onBlur={() => firstNameValidation(firstName)}
                          isInvalid={firstNameInvalid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {firstNameErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Form.Group className="mb-3" controlId="lastName">
                        <Form.Label>Sobrenome</Form.Label>
                        <Form.Control 
                          required 
                          name="lastName"
                          type="text"
                          placeholder="Digite seu sobrenome"
                          onChange={e => setLastName(e.target.value)}
                          onBlur={() => lastNameValidation(lastName)}
                          isInvalid={lastNameInvalid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {lastNameErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Form.Group className="mb-3" controlId="birtDateValidation">
                        <Form.Label>Data de nascimento</Form.Label>
                        <InputMask
                          mask="99/99/9999"
                          value={birthDate}
                          onChange={e => setBirthDate(e.target.value)}
                          onBlur={birthDateValidation}
                        >
                          {(inputProps) => (
                            <Form.Control
                              {...inputProps}
                              type="text"
                              name="birthDate"
                              placeholder="01/01/1990"
                              isInvalid={birthDateInvalid}
                              required
                            />
                          )}
                        </InputMask>
                        <Form.Control.Feedback type="invalid">
                          {birthDateErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Form.Group className="mb-3" controlId="documentValidation">
                        <Form.Label>CPF</Form.Label>
                        <InputMask
                          mask="999.999.999-99"
                          value={document}
                          onChange={e => setDocument(e.target.value)}
                          onBlur={documentValidation}
                        >
                          {(inputProps) => (
                            <Form.Control
                              {...inputProps}
                              type="text"
                              name="document"
                              placeholder="000.000.000-00"
                              isInvalid={documentInvalid}
                              required
                            />
                          )}
                        </InputMask>
                        <Form.Control.Feedback id='validationDocument' type="invalid">
                          {documentErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Form.Group className="mb-3" controlId="emailValidation">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control 
                          type="email" 
                          name="email" 
                          placeholder="Digite seu e-mail"
                          onChange={e => setEmail(e.target.value)}
                          onBlur={() => emailValidation(email)}
                          isInvalid={emailInvalid}
                          required 
                        />
                        <Form.Control.Feedback type="invalid">
                          {emailErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <Form.Group className="mb-3" controlId="phoneValidation">
                        <Form.Label>Celular</Form.Label>
                        <InputMask
                          mask="(99) 99999-9999"
                          value={phone}
                          onChange={e => setPhone(e.target.value)}
                          onBlur={() => phoneValidation(phone)}
                        >
                          {(inputProps) => (
                            <Form.Control
                              {...inputProps}
                              type="text"
                              name="phone"
                              placeholder="(14) 99999-9999"
                              isInvalid={phoneInvalid}
                              required
                            />
                          )}
                        </InputMask>
                        <Form.Control.Feedback type="invalid">
                          {phoneErrorMessage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px', textAlign: 'center' }}>
                      <a href={termoDeAdesao} target="_blank" rel="noopener noreferrer">
                        TERMO DE ADESÃO
                      </a>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px' }}>
                      <Button type='submit' hidden={hideRegisterButton} disabled={loading} className='btn btn-success cor-primaria' style={{ width: '100%' }}>
                        {loading ? (
                            <>
                              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                              {' '}CADASTRANDO. AGUARDE PARA PAGAMENTO...
                            </>
                          ) : (
                            'CADASTRAR'
                          )}
                      </Button>
                      <Alert hidden={!hideRegisterButton} variant="success" className='text-center'>
                        <Alert.Heading>Cadastro realizado com sucesso!</Alert.Heading>
                        <p className="mb-0">
                          Agora só falta realizar o pagamento, clique no botão abaixo para ativar sua matrícula.
                        </p>
                      </Alert>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} hidden={hidePaymentButton} style={{ marginTop: '20px', textAlign: 'center' }}>
                      <Button className='btn btn-success cor-primaria' style={{ width: '100%' }}>
                        <a href='https://mpago.la/2rBdnyw' target='_blank' rel='noopener noreferrer' style={{ color: '#000', textDecoration: 'none' }}>
                          REALIZAR PAGAMENTO
                        </a>
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>            
          </Col>
        </Row>
      </Container>
    </Suspense>
  )
}

export default PageRenderer